import { createAction } from './helpers/createAction'

import { type PostApiV1AccountsUserReselectUserApiArg } from '@wellesley/openapi'
import { type WsSubscribeMessage } from '@wellesley/ws'

export const remoteReady = createAction('remoteReady')
export const askLoginAction = createAction('askLogin')

export const reselectUser =
  createAction<PostApiV1AccountsUserReselectUserApiArg>('reselectUser')

export const requestLogout = createAction('requestLogout')

export const setConfirmLeavePage = createAction<{
  shouldBlock: boolean
  message: string
} | null>('setConfirmLeavePage')

export const requestChangePath = createAction<string>('requestChangePath')

export const wsSubscribe = createAction<WsSubscribeMessage>('wsSubscribe')
export const wsUnSubscribe = createAction<string>('wsUnSubscribe')
